<template>
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="difficulty__icon"
  >
    <path
      d="M23.9545 6.99553V6.99851L19.5373 9.5751L12.0664 5.21127V0.052124L23.9545 6.99553Z"
      :fill="badge.level.isExpert.color"
      :fill-opacity="badge.level.isExpert.opacity"
    />
    <path
      d="M23.9543 6.99851V20.933L19.5371 18.3534V9.57511L23.9543 6.99851Z"
      :fill="badge.level.isAdvanced.color"
      :fill-opacity="badge.level.isAdvanced.opacity"
    />
    <path
      d="M23.9545 20.933V20.9851L12.0664 27.927V22.7679L19.5373 18.4055V18.3534L23.9545 20.933Z"
      :fill="badge.level.isProfessional.color"
      :fill-opacity="badge.level.isProfessional.opacity"
    />
    <path
      d="M12.0663 22.7679V27.927L11.9779 27.9792L0 20.9851V20.9687L4.41718 18.3921V18.4055L11.9779 22.82L12.0663 22.7679Z"
      :fill="badge.level.isProfessional.color"
      :fill-opacity="badge.level.isProfessional.opacity"
    />
    <path
      d="M4.46135 9.54979L4.41718 9.57511V18.3921L0 20.9687V6.99553L0.0441718 6.97021L4.46135 9.54979Z"
      :fill="badge.level.isAdvanced.color"
      :fill-opacity="badge.level.isAdvanced.opacity"
    />
    <path
      d="M12.066 0.0521277V5.21128L11.9777 5.15915L4.46112 9.54979L0.0439453 6.97021L11.9777 0L12.066 0.0521277Z"
      :fill="badge.level.isExpert.color"
      :fill-opacity="badge.level.isExpert.opacity"
    />
  </svg>
</template>

<script>
export default {
  name: 'DifficultyIcon',
  props: {
    difficulty: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
  },
  computed: {
    badge() {
      const color = this.color ? this.color : ''
      const badgeDefaultState = { color: this.badgeColorInactive, opacity: 0.4 }
      const badgeActiveState = { color, opacity: 1 }
      const level = {
        isProfessional: badgeDefaultState,
        isAdvanced: badgeDefaultState,
        isExpert: badgeDefaultState,
      }
      switch (this.difficulty) {
        case 'professional':
          level.isProfessional = badgeActiveState
          break
        case 'advanced':
          level.isProfessional = badgeActiveState
          level.isAdvanced = badgeActiveState
          break
        case 'expert':
          level.isProfessional = badgeActiveState
          level.isAdvanced = badgeActiveState
          level.isExpert = badgeActiveState
          break
        default:
          break
      }
      return { level }
    },
  },
}
</script>

<style lang="scss" scoped>
.difficulty {
  &__icon {
    fill: var(--white);
  }
}
</style>
